module.exports = __webpack_public_path__ + "static/cs-1-1a18e1f328de961d7385f815d27681da.png";